import { invoke } from "@tauri-apps/api/core";
import { getWindowDisplayId } from "@/desktop/use-window-role";
import { getCurrentOwnerEpoch } from "@/lib/owner-state-client";
import { isTauri } from "@/lib/is-tauri";
import { rendersInCurrentWindow } from "./agent-presentation-delivery-trace";
import type {
  AgentPresentation,
  AgentPresentationStep,
} from "./agent-presentation-types";

import { rememberPresentationComponent } from "./presentation-local-receipts";

export type StepComponentState =
  | "started"
  | "finished"
  | "skipped"
  | "waiting"
  | "failed"
  | "cancelled";
export interface PresentationStepReceipt {
  step_id: string;
  visual?: string;
  speech?: string;
  user_action?: string;
  step?: string;
}
export function componentComplete(state?: string): boolean {
  return (
    state === "finished" ||
    state === "skipped" ||
    state === "rendered" ||
    state === "completed"
  );
}
export async function reportStepProgress(
  presentation: AgentPresentation,
  step: AgentPresentationStep,
  component: "speech" | "user_action" | "step",
  state: StepComponentState,
  reason?: string,
): Promise<boolean> {
  rememberPresentationComponent(presentation, step, component, state);
  if (
    !isTauri() ||
    presentation.requestedAcknowledgement === "accepted" ||
    !rendersInCurrentWindow(presentation, step)
  )
    return true;
  const displayId = getWindowDisplayId();
  if (displayId == null) return false;
  try {
    await invoke("report_presentation_step_progress", {
      progress: {
        presentationId: presentation.presentationId,
        executionId: presentation.executionId ?? "",
        stepId: step.step_id,
        displayId,
        ownerEpoch: getCurrentOwnerEpoch(),
        playbackAttempt: presentation.playbackAttempt ?? 1,
        component,
        state,
        reason,
      },
    });
    return true;
  } catch {
    return false;
  }
}

export async function awaitPresentationStep(
  presentation: AgentPresentation,
  step: AgentPresentationStep,
): Promise<boolean> {
  if (!isTauri() || presentation.requestedAcknowledgement === "accepted")
    return true;
  try {
    return await invoke<boolean>("await_presentation_step", {
      progress: {
        presentationId: presentation.presentationId,
        executionId: presentation.executionId ?? "",
        stepId: step.step_id,
        displayId: getWindowDisplayId(),
        ownerEpoch: getCurrentOwnerEpoch(),
        playbackAttempt: presentation.playbackAttempt ?? 1,
      },
    });
  } catch {
    return false;
  }
}
